import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    fetchUserSavedHeatmapData,
    updateUserSavedHeatmapData,
    deleteUserSavedHeatmapData
} from "./HeatmapXUserSegmentAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  user_saved_heatmaps: [],
  selectedHeatmapId: null,
  selectedHeatmapIdData: null,
  website_routes: [],
  currentHeatmapData: {},
  siteUsersDBData: {},
  siteFunnelDBData: {},
  siteHeatmapUsersWeekLabels: [],
  siteUserJourneyUserWeekLabels: [],
  siteUsersWeekData: [],
  currentHeatMapDetail: {},
  screenshortURLs: [],
  currentSelectedWeek: "",
  currentSelectedPage: "",
  currentSelectedJourneyPath: [], // array of node names representing the selected path
  heatmapActiveDateRange: null,  // { start: 'YYYY-MM-DD', end: 'YYYY-MM-DD' } or null
  journeyActiveDateRange: null,  // { start: 'YYYY-MM-DD', end: 'YYYY-MM-DD' } or null
};



export const fetchUserHeatmap = createAsyncThunk(
  "userHeatmap/fetch",
  async (statsObj, { rejectWithValue }) => {
    const [user, graph] = statsObj.split('/');
    console.log("fetchUserHeatmap statsObj", statsObj, user, graph)
    try {
      console.log("fetchUserHeatmap statsObj inside", statsObj)
      const response = await fetchUserSavedHeatmapData(statsObj, user, graph);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const updateUserHeatmap = createAsyncThunk(
  "userHeatmap/update",
  async ({ statsObj, payload }, { rejectWithValue }) => {
    try {
      const response = await updateUserSavedHeatmapData(statsObj, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateUserWebsiteRoutes = createAsyncThunk(
  "userHeatmap/updateWebsiteRoutes",
  async ({ statsObj, payload }, { rejectWithValue }) => {
    try {
      const response = await updateUserSavedHeatmapData(statsObj, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteUserHeatmap = createAsyncThunk(
  "userHeatmap/delete",
  async (statsObj, { rejectWithValue }) => {
    try {
      const response = await deleteUserSavedHeatmapData(statsObj);
      return response.response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const userHeatmapSlice = createSlice({
  name: "userHeatmap",
  initialState,
  reducers: {
    resetUserHeatmapSlice: (state, action) => {
      return { ...initialState };
    },
    updateUserDesignData: (state, action) => {
      const nudge_data = action.payload;
      state.data[nudge_data.id] = nudge_data;
      state.user_saved_designs = state.user_saved_designs.map((item) => {
        if (item[0] === nudge_data.id) return [nudge_data.id, nudge_data];
        else return item;
      });
    },
    addUserDesignData: (state, action) => {
      let nudge_data = action.payload;
      state.data[nudge_data.id] = nudge_data;
      state.user_saved_designs.unshift([nudge_data.id, nudge_data]);
    },
    deleteUserSavedDesign: (state, action) => {
      let designId = action.payload;
      delete state.data[designId];
      state.user_saved_designs = state.user_saved_designs.filter(
        (item) => item.id !== designId
      );
    },
    setCurrentHeatmapData: (state, action) => {
      state.currentHeatmapData = action.payload;
    },
    setCurrentHeatMapDetail: (state, action) => {
      state.currentHeatMapDetail = action.payload;
    },
    setCurrentHeatmapURL: (state, action) => {
      state.currentHeatmapData.userSelection.targetRoute = action.payload;
    },
    setSiteUsersDBData: (state, action) => {
      let modified_data = action.payload
      state.siteUsersDBData = modified_data;
      // state.siteUsersWeekLabels = Object.keys(modified_data)
      state.siteUsersWeekData = Object.values(modified_data)
    },
    setSiteHeatmapUserWeekLabels: (state, action) => {
      state.siteHeatmapUsersWeekLabels = action.payload;
    },
    setSiteUserJourneyUserWeekLabels: (state, action) => {
      state.siteUserJourneyUserWeekLabels = action.payload;
    },
    setFunnelViewDBData: (state, action) => {
      let modified_data = action.payload;
      state.siteFunnelDBData = modified_data;
      // state.siteUsersWeekLabels = Object.keys(modified_data)
      // state.siteUsersWeekData = Object.values(modified_data)
    },
    setCurrentSelectedWeek: (state, action) => {
      state.currentSelectedWeek = action.payload;
    },
    setCurrentSelectedPage: (state, action) => {
      state.currentSelectedPage = action.payload;
    },
    setCurrentSelectedJourneyPath: (state, action) => {
      state.currentSelectedJourneyPath = action.payload;
    },
    setHeatmapActiveDateRange: (state, action) => {
      state.heatmapActiveDateRange = action.payload; // null or { start, end }
    },
    setJourneyActiveDateRange: (state, action) => {
      state.journeyActiveDateRange = action.payload; // null or { start, end }
    },
    updatePropertyVal: (state, action) => {
      let { key, val } = action.payload;
      state[key] = val;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserHeatmap.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserHeatmap.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        state.data = result;
        state.website_routes = result?.["website-info"]?.routes || [];
        state.user_saved_heatmaps = Object.values(result?.["heat-map-data"] || {});
        state.screenshortURLs = Object.values(result?.["screenshortURLs"] || {});
        // state.screenshortURLs = result?.["screenshortURLs"] || [];
        console.log("db heatmap data", result)
      })
      .addCase(fetchUserHeatmap.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      })
      .addCase(updateUserHeatmap.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateUserHeatmap.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
      })
      .addCase(updateUserHeatmap.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      })
      .addCase(updateUserWebsiteRoutes.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateUserWebsiteRoutes.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
      })
      .addCase(updateUserWebsiteRoutes.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      })
      .addCase(deleteUserHeatmap.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteUserHeatmap.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
      })
      .addCase(deleteUserHeatmap.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      })
  },
});

export const {
  resetUserHeatmapSlice,
  updateUserDesignData,
  addUserDesignData,
  deleteUserSavedDesign,
  setCurrentHeatmapData,
  setCurrentHeatmapURL,
  setSiteUsersDBData,
  setCurrentHeatMapDetail,
  updatePropertyVal,
  setFunnelViewDBData,
  setSiteHeatmapUserWeekLabels,
  setSiteUserJourneyUserWeekLabels,
  setCurrentSelectedWeek,
  setCurrentSelectedPage,
  setCurrentSelectedJourneyPath,
  setHeatmapActiveDateRange,
  setJourneyActiveDateRange,
} = userHeatmapSlice.actions;

export const SelectUserDBHeatmaps = (state) =>
  state.userHeatmap.user_saved_heatmaps;
export const SelectUserDesignsStatus = (state) => state.userHeatmap.status;
export const SelectUserWebsiteRoutes = (state) => state.userHeatmap.website_routes;
export const SelectCurrentHeatmapData = (state) => state.userHeatmap.currentHeatmapData;
export const SelectSiteUsersDBData = (state) => state.userHeatmap.siteUsersDBData;
export const SelectSiteHeatmapUsersWeekLabels = (state) => state.userHeatmap.siteHeatmapUsersWeekLabels;
export const SelectSiteUserJourneyUserWeekLabels = (state) => state.userHeatmap.siteUserJourneyUserWeekLabels;
export const SelectSiteUsersWeekData = (state) => state.userHeatmap.siteUsersWeekData;
export const SelectCurrentHeatMapDetail = (state) => state.userHeatmap.currentHeatMapDetail;
export const SelectScreenshortURLs = (state) => state.userHeatmap.screenshortURLs;
export const SelectSiteFunnelDBData = (state) => state.userHeatmap.siteFunnelDBData;
export const SelectCurrentSelectedWeek = (state) => state.userHeatmap.currentSelectedWeek;
export const SelectCurrentSelectedPage = (state) => state.userHeatmap.currentSelectedPage;
export const SelectCurrentSelectedJourneyPath = (state) => state.userHeatmap.currentSelectedJourneyPath;
export const SelectHeatmapActiveDateRange = (state) => state.userHeatmap.heatmapActiveDateRange;
export const SelectJourneyActiveDateRange = (state) => state.userHeatmap.journeyActiveDateRange;



export default userHeatmapSlice.reducer;

function getWeekWiseData(data) {
  console.log("get week wise data called->",data)
  let result = {}
  Object.entries(data).forEach(([weekLabel, weekData]) => {
    let newWeekData = {}
    Object.entries(weekData).forEach(([url, urlData]) => {
      // let newURL = url.replaceAll("~~", "/").replaceAll('_', '.');
      let newURL = decodeURIComponent(url);
      newWeekData[newURL] = urlData;
    })
    result[weekLabel] = newWeekData
  })
  return result;
}


// function getWeekWiseData(data) {
//   let result = {}
//   Object.entries(data).forEach(([year, yearData]) => {
//     Object.entries(yearData).forEach(([month, monthData]) => {
//       Object.entries(monthData).forEach(([week, weekData]) => {
//         let weekKey = `${year}/${month}/${week}`;
//         let newWeekData = {}
//         Object.entries(weekData).forEach(([url, urlData]) => {
//           let newURL = url.replaceAll("~~", "/");
//           newWeekData[newURL] = urlData;
//         })
//         result[weekKey] = newWeekData
//       })
//     })
//   })
//   return result;
// }